module.exports = __webpack_public_path__ + "2c8c5b8f50a0fa7c5c882861489c0036.svg";